import React, { memo } from 'react';
import PropTypes from 'prop-types';
import AllowedStateUserGroupItemComponent from './AllowedStateUserGroupItemComponent';

const AllowedStateUserGroupListComponent = ({ allowedState, userGroups, dispatch, changedAllowedStatesPermission }) => {
  return userGroups.map(userGroup => {
    return (
      <AllowedStateUserGroupItemComponent
        key={userGroup.id}
        userGroup={userGroup}
        allowedState={allowedState}
        dispatch={dispatch}
        changedAllowedStatesPermission={changedAllowedStatesPermission[userGroup.id]}
      />
    );
  });
};

AllowedStateUserGroupListComponent.propTypes = {
  allowedState: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  changedAllowedStatesPermission: PropTypes.object.isRequired
};

export default memo(AllowedStateUserGroupListComponent);
